<template>
  <v-card class="hpo-counts-block hpo-counts-block--hospital-capacity"
          @click="displayHospitalModal"
          :title="hospital.name">
    <div class="hpo-counts-block__body d-flex flex-column justify-center align-center">
      <div class="mb-2">{{ pgettext('label', 'Free capacity') }}:</div>
      <div class="hpo-counts-block__values">
        <v-chip color="red" density="compact" variant="flat" :ripple="false" rounded
                class="hpo-counts-block__value px-2">
          <strong>
            {{ counterValue(hospital.red) }}
          </strong>
        </v-chip>
        <v-chip color="yellow" density="compact" variant="flat" :ripple="false" rounded
                class="hpo-counts-block__value px-2">
          <strong>
            {{ counterValue(hospital.yellow) }}
          </strong>
        </v-chip>
        <v-chip color="green" density="compact" variant="flat" :ripple="false" rounded
                class="hpo-counts-block__value px-2">
          <strong>
            {{ counterValue(hospital.green) }}
          </strong>
        </v-chip>
      </div>
    </div>
    <div v-if="allowEdit"
         class="hpo-counts-block__footer">
      <v-btn variant="elevated"
             density="compact"
             :prependIcon="mdiPencilOutline()"
             block>
        <span>{{ pgettext('action', 'Edit') }}</span>
      </v-btn>
    </div>
  </v-card>

</template>

<script>
import {HpoRole} from "../../choices";
import {mdiPencilOutline} from "@mdi/js";

export default {
  name: "HospitalListItem",
  emits: ['displayHospitalModal'],
  props: {
    hospital: {
      type: Object,
      required: true
    },
    member: {
      type: Object,
      required: true
    },
  },
  setup() {
    return {
      // Imports
      HpoRole,
    }
  },
  computed: {
    allowEdit() {
      return !!(
        (
          this.member.role === this.HpoRole.CONTACT_POINT &
          this.member.hospitals.includes(parseInt(this.hospital.id))
        ) |
        (
          this.member.role === this.HpoRole.ZOS
        )
      );
    }
  },
  methods: {
    mdiPencilOutline() {
      return mdiPencilOutline
    },
    counterValue(value) {
      if (value === null) {
        return '?'
      }
      return value
    },
    displayHospitalModal() {
      if (this.allowEdit === true) {
        this.$emit('displayHospitalModal', this.hospital)
      }
    }
  }
}
</script>
